export const legacyActivateALinePath = "/lines/new"
export const activateALinePath = "/phone-system/lines/new"
